import { styled as styling } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import ConnorsTheme from "../connorsTheme";

export const SectionTitle = styling(Typography)((props) => ({
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.27px",
  color: ConnorsTheme.red,

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "14px",
    letterSpacing: "0.21px",
  },
}));

export const SectionDescription = styling(Typography)((props) => ({
  fontSize: "40px",
  fontWeight: 400,
  fontFamily: "Georgia",
  fontStyle: "normal",
  lineHeight: "120%",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "2rem",
  },

  [props.theme.breakpoints.down("md")]: {
    fontSize: "1.5rem",
  },
}));

export const DisclaimerText = styling(Typography)((props) => ({
  display: "inline",
  padding: "10px 24px 40px",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",

  fontSize: "14px",
  fontWeight: 400,
  fontFamily: "Inter",
  fontStyle: "normal",
  lineHeight: "24px",
  letterSpacing: "0.15px",
  textAlign: "center",
  color: "#222",

  "& a": {
    color: "#222",
    textDecoration: "underline",
    fontWeight: 700,
  },
  "& i": {
    fontSize: "12px",
    color: "#222",
    fontStyle: "normal",
    fontWeight: 700,
  },
}));
